export const GET_FURNITURE_ITEMS = 'GET_FURNITURE_ITEMS';
export const GET_PURCHASED_FURNITURE = 'GET_PURCHASED_FURNITURE';
export const GET_FURNITURE_REQUEST = 'GET_FURNITURE_REQUEST';
export const GET_FURNITURE_PROPOSAL = 'GET_FURNITURE_PROPOSAL';
export const GET_FURNITURE_MOVMENT = 'GET_FURNITURE_MOVMENT';
export const GET_FURNITURE_COLLECTOR = 'GET_FURNITURE_COLLECTOR';
export const GET_FURNITURE_INVENTORY = 'GET_FURNITURE_INVENTORY';
export const GET_FURNITURE_DISTRIBUTERS = 'GET_FURNITURE_DISTRIBUTERS';
